// generated from 86_404 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const countryFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("country_filter"),
  comparison_key: z.enum([
    "1", // 72_190 (83.55%)
    "2", // 7_481 (8.66%)
    "25", // 3_978 (4.60%)
    "26", // 2_702 (3.13%)
    "12", // 38 (0.04%)
    "11", // 13 (0.02%)
    "27", // 2 (0.00%)
  ]),
  display_name: z.string(),
  // undefined: 23_726 (27.46%), defined 62_678 (72.54%)
  raw_value: z
    .union([
      // string samples: 57_985 (92.51%)
      z.string(),
      // array samples: 4_693 (7.49%)
      z.array(z.string().length(2)),
    ])
    .optional(),
  value: z.union([
    // array samples: 6_682 (7.73%)
    z.array(
      z.object({
        id: z.string().length(2),
        value: z.string(),
      })
    ),
    // object samples: 79_722 (92.27%)
    z.object({
      id: z.string(),
      value: z.string(),
    }),
  ]),
  varies_by_app_group: z.literal(false),
});
